<template>
    <div>

        <b-row align-v="center" class="report-chart-block">

            <!-- K 線圖 -->
            <b-col class="col-12 col-lg-8">

                <div class="report-chart-title">
                    {{ $t('report.ui.daily') }} {{ $t('sensor.soil_conductivity') }} {{ $t('report.ui.kchart') }}
                </div>
                <div class="device">
                    <div class="device-sensor-blocks">
                        {{ $t('sensor.soil_conductivity') }}<div class="device-unit" v-html="$t('sensor.u_soil_conductivity')"></div>
                    </div>
                </div>

                <div class="print-chart-scroll">
                    <div class="print-chart-area">
                        <KChartCandlestick v-if="timeData['day']" :chartID="'device-chart-soil_conductivity-' + deviceHashid + '-001'"
                                            :info_type="'report'"
                                            :sensorCode="'soil_conductivity'"
                                            :data="kChart_Data"
                                            :dataName="kChart_DataName"
                                            :time="timeData['day']"
                                            :deviceInfo="deviceInfo"
                                            :deviceType="'device'"
                                            :showToolbox="true"
                                            :rightToolbox="false"
                                            :xAxisName="'date'" :xAxisFormat="'MM/DD'"
                                            :defaultBounding="[ 0, 0.2 ]"
                        ></KChartCandlestick>
                    </div>
                </div>
            </b-col>
            <b-col class="col-12 col-lg-4">
                <b-alert show variant="success">
                    <h4 class="">
                        <i :class="$tools.style.classIcon(deviceInfo.type, 'block-title')"></i>
                        <div class="block-text">{{ deviceInfo.nickname }}</div>
                        <div class="block-text">( {{ deviceHashid }} )</div>
                    </h4>
                    <div>
                        <div class="block-text">{{ $t('sensor.avg_daily_soil_conductivity') }} ：</div>
                        {{ deviceData['soil_conductivity'].avg_daily_soil_conductivity }} {{ $t('sensor.u_avg_daily_soil_conductivity') }}
                    </div>
                    <div>
                        <div class="block-text">{{ $t('sensor.avg_daily_high_soil_conductivity') }} ：</div>
                        {{ deviceData['soil_conductivity'].avg_daily_high_soil_conductivity }} {{ $t('sensor.u_avg_daily_high_soil_conductivity') }}
                    </div>
                    <div>
                        <div class="block-text">{{ $t('sensor.avg_daily_low_soil_conductivity') }} ：</div>
                        {{ deviceData['soil_conductivity'].avg_daily_low_soil_conductivity }} {{ $t('sensor.u_avg_daily_low_soil_conductivity') }}
                    </div>
                    <div>
                        <InstrKChart></InstrKChart>
                    </div>
                </b-alert>
            </b-col>
            
        </b-row>
        <b-row align-v="center" class="report-chart-block">

            <!-- 殘差值 趨勢圖 -->
            <b-col class="col-12 col-lg-8">

                <div class="report-chart-title">
                    {{ $t('report.ui.daily') }} {{ $t('sensor.soil_conductivity_residual') }} {{ $t('report.ui.chart') }}
                </div>
                <div class="device">
                    <div class="device-sensor-blocks">
                        {{ $t('sensor.soil_conductivity') }}<div class="device-unit" v-html="$t('sensor.u_soil_conductivity')"></div>
                    </div>
                    <div class="device-sensor-blocks">
                        {{ $t('sensor.soil_moisture') }}<div class="device-unit" v-html="$t('sensor.u_soil_moisture')"></div>
                    </div>
                    <div class="device-sensor-blocks">
                        {{ $t('sensor.soil_conductivity_residual') }}<div class="device-unit" v-html="$t('sensor.u_soil_conductivity_residual')"></div>
                    </div>
                </div>

                <div class="print-chart-scroll">
                    <div class="print-chart-area">
                        <MixChartMultipleParams v-if="timeData['hour']" :chartID="'device-chart-soil_conductivity-' + deviceHashid + '-002'"
                                            :info_type="'report'"
                                            :time="timeData['hour']"
                                            :dataList="mixChart_Data"
                                            :dataDisplaySettings="dataDisplaySettings"
                                            :chartTitle="'Report Soil Conductivity Residual'"
                                            :showToolbox="true"
                                            :showDeviceName="false"
                                            :showRainfallsLabel="false"
                                            :rightToolbox="false"
                                            :xAxisName="'date'" :xAxisFormat="'MM/DD HH:mm'"
                        ></MixChartMultipleParams>
                    </div>
                </div>
            </b-col>
            <b-col class="col-12 col-lg-4">
                <b-alert show variant="success">
                    <h4 class="">
                        <i :class="$tools.style.classIcon(deviceInfo.type, 'block-title')"></i>
                        <div class="block-text">{{ deviceInfo.nickname }}</div>
                        <div class="block-text">( {{ deviceHashid }} )</div>
                    </h4>
                    <div>
                        <InstrECResidual></InstrECResidual>
                    </div>
                </b-alert>
            </b-col>

        </b-row>

    </div>
</template>

<script>
import ecTools from '@/echarts/echarts-tools'
import MixChartMultipleParams from '@/views/echarts/MixChart_MultipleParams'
// import MixChartMinMaxParamData from '@/views/echarts/MixChart_MinMaxParamData'
import KChartCandlestick from '@/views/echarts/KChart_Candlestick'
import InstrKChart       from '@/views/project/report/components/Instructions/instr_k_chart'
import InstrECResidual   from '@/views/project/report/components/Instructions/instr_EC_residual'

export default {
    props: {
        deviceHashid: {
            type: String,
            required: true,
        },
        deviceData: {
            type: Object,
            required: true,
        },
        deviceInfo: {
            type: Object,
            default: {},
        },
        timeData: {
            type: Object,
            default: function () { return {} }
        },
        dataDisplaySettings: {
            type: Array,
            default: function () { return [] }
        },
    },
    components: {
        MixChartMultipleParams,
        // MixChartMinMaxParamData,
        KChartCandlestick,
        InstrKChart,
        InstrECResidual,
    },
    data () {
        return {
            kChart_Data: [],
            kChart_DataName: [
                // 轉成 echarts 格式：[open, close, lowest, highest] （即：[开盘值, 收盘值, 最低值, 最高值]）
                'daily_start_soil_conductivity',   // 起始值
                'daily_end_soil_conductivity',     // 結束值
                'daily_low_soil_conductivity',     // 日最低
                'daily_high_soil_conductivity',    // 日最高
            ],
            mixChart_Data: {},
        }
    },
    mounted ()
    {
        this.arrangeData_for_KChart()
        this.arrangeData_for_mixChart()
    },
    watch: {
        deviceData (val, oldVal)
        {
            this.arrangeData_for_KChart()
            this.arrangeData_for_mixChart()
        },
    },
    methods: {

        arrangeData_for_KChart ()
        {
            this.kChart_Data = []

            for (let i=0; i<this.timeData['day'].length; i++)
            {
                this.kChart_Data.push([
                    this.deviceData['soil_conductivity'][ this.kChart_DataName[0] ][i],
                    this.deviceData['soil_conductivity'][ this.kChart_DataName[1] ][i],
                    this.deviceData['soil_conductivity'][ this.kChart_DataName[2] ][i],
                    this.deviceData['soil_conductivity'][ this.kChart_DataName[3] ][i],
                ])
            }
        },

        arrangeData_for_mixChart ()
        {
            this.mixChart_Data = {
                soil_conductivity:          this.deviceData['soil_conductivity_residual']['soil_conductivity'],
                soil_moisture:              this.deviceData['soil_conductivity_residual']['soil_moisture'],
                soil_conductivity_residual: this.deviceData['soil_conductivity_residual']['soil_conductivity_residual'],
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>